import React from 'react'
import { Input, InputCheck, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { montaTypeOptions } from 'src/constants/montaType'
import { formatDateToInputValue } from 'src/utils'
import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { BirthRegistrationParams } from '.'

interface ReproductionDetailsSectionProps {
  useDateInterval: boolean
  isLoadingAnimal: boolean
  handleToggleDateInterval: () => void
  validateDateNotFuture: (value: string, fieldName: string, fieldLabel: string) => boolean
}

export const ReproductionDetailsSection: React.FC<ReproductionDetailsSectionProps> = ({
  useDateInterval,
  isLoadingAnimal,
  handleToggleDateInterval,
  validateDateNotFuture
}) => {
  const style = useStyles()
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<BirthRegistrationParams>()

  const tipoReproducao = watch('tipoReproducao')
  const dataCobertura = watch('dataCobertura')
  const dataInicial = watch('dataInicial')
  const today = new Date().toISOString().split('T')[0]

  return (
    <section className={`${style.section} ${style.reproductionSection}`}>
      <h2 className={style.sectionTitle}>Detalhes da Reprodução</h2>
      <div className={style.reproductionInfoContainer}>
        <div className={`${style.infoGrid} ${useDateInterval ? style.singleColumnGrid : ''}`}>
          <div className={style.formControl}>
            <SelectInput
              label='Tipo de reprodução'
              value={tipoReproducao}
              options={montaTypeOptions}
              selectBy='id'
              showBy={['value']}
              placeholder='Selecionar tipo de reprodução'
              error={errors?.tipoReproducao?.message}
              disabled={isLoadingAnimal}
              onChange={(option: any) => {
                setValue('tipoReproducao', option?.id || '')
                clearErrors('tipoReproducao')
              }}
            />
          </div>
          {!useDateInterval && (
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data da Cobertura'
                value={formatDateToInputValue(dataCobertura || '')}
                disabled={isLoadingAnimal}
                error={errors?.dataCobertura?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataCobertura', 'Data da Cobertura')) {
                    setValue('dataCobertura', value)
                    clearErrors('dataCobertura')
                  } else {
                    setValue('dataCobertura', value)
                  }
                }}
              />
            </div>
          )}
        </div>
        <div className={style.formControl}>
          <InputCheck
            id='useDateInterval'
            type='checkbox'
            name='date_interval'
            value='intervalo'
            label='Intervalo de datas'
            checked={useDateInterval}
            disabled={isLoadingAnimal}
            onChange={handleToggleDateInterval}
          />
        </div>
        {useDateInterval && (
          <div className={style.infoGrid}>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data início'
                value={formatDateToInputValue(dataInicial || '')}
                disabled={isLoadingAnimal}
                error={errors?.dataInicial?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataInicial', 'Data início')) {
                    setValue('dataInicial', value)
                    clearErrors('dataInicial')
                  } else {
                    setValue('dataInicial', value)
                  }
                }}
              />
            </div>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data final'
                value={formatDateToInputValue(watch('dataFim') || '')}
                disabled={isLoadingAnimal}
                error={errors?.dataFim?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataFim', 'Data final')) {
                    setValue('dataFim', value)
                    clearErrors('dataFim')
                  } else {
                    setValue('dataFim', value)
                  }
                }}
              />
            </div>
          </div>
        )}
        <div className={style.formControl}>
          <SelectAnimalFetchInput
            label='Touro'
            selectBy='id'
            showBy={['cdn', 'nome']}
            filteredSex='Macho'
            value={watch('touro')}
            error={errors?.touro?.message}
            placeholder='Selecionar touro'
            disabled={isLoadingAnimal}
            onChange={(item: any) => {
              setValue('touro', item?.id || '')
              clearErrors('touro')
            }}
          />
        </div>
      </div>
    </section>
  )
}
